const ContentFlow = () => {
    return (
        <div id="bot-scene-container" className="">
            <div id="bot-scene-content" className="scroll-light">
                <div className="app-v2-header-wrapper has-subtitle has-extra">
                    <div className="app-v2-header-left">
                        <span className="app-v2-header-title">
                            Nội dung</span>
                        <span className="app-v2-header-subtitle">
                            Quản lý nội dung các kịch bản
                        </span>
                    </div>
                    <div className="app-v2-header-extra-wrapper">
                        <div><button type="button"
                            className="app-btn app-btn-default btn-menu-manager-folder">
                            <div className="svg-next-icon">
                            </div>
                        </button>
                        </div>
                        <button className="btn btn-primary p-sm-l p-sm-r app-v2-gtm-auto-keyword-new ml15">
                            <span>
                                + Tạo mới nội dung
                            </span>
                        </button>
                    </div>
                </div>

                <div className="app-v2-layout-content">
                    <div>
                        <div className="hrs-filter-container-master">
                            <div className="hrs-filter-container">
                                <div className="hrs-filter-wrapper">
                                    <div className="hrs-btn-open-filter">
                                        <div className="svg-next-icon icon-filter">
                                        </div>
                                        <span>Bộ lọc tìm kiếm</span>
                                    </div>
                                </div>
                                <div className="hrs-filter-search-wrapper">
                                    <svg width="16" height="16" viewBox="0 0 16 16">
                                        <path fill="#8993A4" fillRule="evenodd"
                                            d="M6.8 13.6a6.8 6.8 0 115.34-2.59l3.626 3.624a.8.8 0 01-1.132 1.132L11.01 12.14A6.77 6.77 0 016.8 13.6zm3.728-3.175a.817.817 0 00-.103.103 5.2 5.2 0 11.102-.102z"
                                            clipRule="evenodd"></path>
                                    </svg >
                                    <input className="hrs-filter-input-search" placeholder="Tìm kiếm" value="" />
                                </div>
                            </div>
                        </div>

                        <div className="app-table-container ref-parameters--container app-scrollbar app-scrollbar-visible">
                            <table className="app-table app-table--vertical-middle">
                                <thead>
                                    <th className="text-left-i" style={{ width: "100%" }}>Tên</th>
                                    <th className="text-left-i" style={{ width: "150px" }}>Thư mục</th>
                                    <th className="text-left-i" style={{ width: "130px" }}>Tin nhắn đã gửi</th>
                                    <th className="text-left-i" style={{ width: "100px" }}>Hành động</th>
                                </thead>
                                <tbody>
                                    <tr className="app-v2-table-tr pointer">
                                        <td className="app-v2-table-td text-left-i" style={{ width: "100%" }}>
                                            <div className="content-title-wrapper">
                                                <div className="icon">
                                                    <div className="svg-next-icon">
                                                    </div>
                                                </div>
                                                <div className="content">
                                                    <span title="ref_copy_10109">
                                                        ref_copy_10109
                                                        </span>
                                                    <span className="ntn-subtitle">
                                                        <span>Hôm nay lúc 01:32 CH</span>
                                                    </span>
                                                </div>
                                            </div>
                                        </td>
                                        <td className="app-v2-table-td text-left-i" style={{ width: "150px" }}>
                                            <div className="folders-wrapper">
                                                <div className="svg-next-icon" >
                                                </div><span className="folder-name" title="Mặc định">Mặc định</span>
                                            </div>
                                        </td>
                                        <td className="app-v2-table-td text-right-i" style={{ width: "130px" }}>0</td>
                                        <td className="app-v2-table-td text-center-i">
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="table-wrapper">
                            <div className="app-report-table--pagination">
                                <div className="app-pagination ">
                                    <div className="app-pagination--options">
                                        <div className="app-pagination-dropdown">
                                            <div className="app-pagination-dropdown--text">Hiển thị</div>
                                            <div className="app-pagination-dropdown--btn">
                                                <div className="app-pagination-dropdown--number">20</div>
                                                <div className="app-pagination-dropdown--icon">
                                                    <svg className="app-svg-inline-block app-svg-next-icon-rotate-90" width="16px"
                                                        height="16px" viewBox="0 0 16 16">
                                                        <path d="M6.47 4L5.53 4.94L8.58333 8L5.53 11.06L6.47 12L10.47 8L6.47 4Z">
                                                        </path>
                                                    </svg>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <ul className="app-pagination--listpage">
                                        <li className="app-pagination-total-text">Đang hiển thị 1-1 /  8 </li>
                                        <li className="app-pagination--item app-pagination--item-active">
                                            <a>1</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default ContentFlow